module.exports = __webpack_public_path__ + "img/whatsapp.7ed43415.svg";